import React, {useEffect, useState} from 'react';
import $ from "jquery";
import formatNumber from "../../utils/formatNumber";
import feather from "feather-icons";
import {getPageStat, userReport} from "../../api/app";
import cogoToast from "cogo-toast";

const UserReport = (props) => {

    const [pages, setPages] = useState([]);
    const [tiktok, setTiktok] = useState(null);

    useEffect(() => {
        feather.replace();
    }, []);

    useEffect(() => {
        userReport(props.id).then((response) => {
            $("#total-assignment").text(formatNumber(response.payload.total_task));
            $("#total-users").text(formatNumber(response.payload.total_submission));
            setTiktok(response.payload?.tiktok);
            setPages(response.payload?.social?.pages);
        });
    }, []);

    const showPageInsight = (data) => {
        let { hide } = cogoToast.loading(
            'Please wait... contacting Facebook server.',
            { position: "top-right", hideAfter: 0 }
        );

        getPageStat(data.id).then((response) => {
            hide();

            if (response.error) {
                cogoToast.error("Failed to load Facebook insights");
                return;
            }

            const insights = response.payload?.data || [];

            // ---- Extract reach by period ----
            let dailyReach = 0;
            let weeklyReach = 0;
            let monthlyReach = 0;

            insights.forEach(metric => {
                const latestValue =
                    metric.values?.[metric.values.length - 1]?.value || 0;

                if (metric.period === "day") dailyReach = latestValue;
                if (metric.period === "week") weeklyReach = latestValue;
                if (metric.period === "days_28") monthlyReach = latestValue;
            });

            // ---- Update numbers (jQuery) ----
            $("#total-likes").text(dailyReach);
            $("#total-comments").text(weeklyReach);
            $("#total-shares").text(monthlyReach);

            // ---- Engagement (simple example logic) ----
            const engagements = dailyReach + weeklyReach + monthlyReach;
            $("#total-engagements").text(engagements);

            // ---- Optional labels (safe defaults) ----
            $("#total-reactions").text(dailyReach);

            // ---- Show modal ----
            $("#modalPageInsightReport").modal({
                backdrop: 'static',
                focus: false,
                show: true
            });

            $("#page-name").text(data.name);
            $("#page-follower").text(data.followers_count);
            $("#page-logo").attr("src", data.picture.data.url);
            $("#page-category").text(`PageID: ${data.id}`);
        });
    };

    return (
        <div className="col-12 col-lg-12">
            <div className="card mg-b-10">
                <div className="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                    <div>
                        <h6 className="mg-b-5">Influencer Performance</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">App user Performance.</p>
                    </div>
                </div>

                <div className="card-body pd-y-10">
                    <div className="d-sm-flex">
                        <div className="media align-items-center">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Total Tasks</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                            </div>
                        </div>
                        <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Total Submissions</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-users">0</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <div>
                    <div className="card-header d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                        <div>
                            <h6 className="mg-b-5">Social Metric</h6>
                            <p className="tx-13 tx-color-03 mg-b-0">Performance.</p>
                        </div>
                    </div>

                    <div className="card-body pd-y-30">
                        <div className="d-sm-flex">
                            <div className="media align-items-center">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6" style={{backgroundColor: "#1877F2"}}>
                                    <i className="fab fa-facebook tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap">Facebook</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">0</h4>
                                </div>
                            </div>
                            <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-black-9 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                    <i className="fab fa-tiktok tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">TikTok</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                                </div>
                            </div>
                            <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                    <i className="fab fa-twitter tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Twitter</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-dashboard mg-b-0">
                            <thead>
                            <tr>
                                <th>Social Platform</th>
                                <th className="text-right">Reach</th>
                                <th className="text-right">Engagement</th>
                                <th className="text-right">Views</th>
                                <th className="text-right">Shares</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-facebook mg-r-4"></i>Facebook</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>

                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize" style={{color: "black"}}><i className="fab fa-tiktok mg-r-4"></i>Tiktok</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>

                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-twitter mg-r-4"></i>Twitter</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr/>

                <div className="card-body pd-y-10">
                    <div className="mb-3">
                        <h6 className="mg-b-5">Facebook Pages</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">Influencer Page Stats & Associated Facebook Account.</p>
                    </div>
                    {pages?.length > 0 ? <div className="row mb-3">
                        {pages.map((data) => (
                            <div className="col-sm-6 col-lg-4 mb-3">
                                <div className="card card-body">
                                    <a href="javascript:void(0)" className="link-02" onClick={() => showPageInsight(data)}>
                                        <div className="d-flex justify-content-between mt-1">
                                            <div className="media">
                                                <div className="crypto-icon crypto-icon-sm bg-primary">
                                                    <img src={data.picture.data.url} className="ht-50 rounded-30" alt="logo"/>
                                                </div>
                                                <div className="media-body mg-l-15">
                                                    <p className="tx-medium mg-b-0">{data.name}</p>
                                                    <p className="mg-b-0 tx-12 tx-color-03 tx-medium tx-spacing-1">PageID: {data.id}</p>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <p className="tx-normal tx-rubik mg-b-0">Follower</p>
                                                <p className="tx-normal tx-rubik mg-b-0 float-right">{formatNumber(data.followers_count)}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div> : <h6 className="tx-danger">No Pages Connected.</h6>}
                </div>

                <hr/>

                <div className="card-body pd-y-10">
                    <div className="mb-3">
                        <h6 className="mg-b-5">TikTok Pages</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">Influencer Page Stats & Associated TikTok Account.</p>
                    </div>
                    {tiktok !== null ? <div className="row mb-3">
                        <div className="col-sm-6 col-lg-4 mb-3">
                            <div className="card card-body">
                                <a href={`https://www.tiktok.com`} target="_blank" className="link-02">
                                    <div className="d-flex justify-content-between mt-1">
                                        <div className="media">
                                            <div className="crypto-icon crypto-icon-sm bg-primary">
                                                <img src={tiktok.profile.avatarUrl} className="ht-50 rounded-30" alt="logo"/>
                                            </div>
                                            <div className="media-body mg-l-15">
                                                <p className="tx-medium mg-b-0">Display Name</p>
                                                <p className="mg-b-0 tx-12 tx-color-03 tx-medium tx-spacing-1">{tiktok.profile.displayName}</p>
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            <p className="tx-normal tx-rubik mg-b-0">Follower</p>
                                            <p className="tx-normal tx-rubik mg-b-0 float-right">{formatNumber(tiktok.profile.followerCount)}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div> : <h6 className="tx-danger">No Pages Connected.</h6>}
                </div>
            </div>

            <div
                className="modal fade"
                id="modalPageInsightReport"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="pageInsightModal"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content tx-14">

                        {/* Header */}
                        <div className="modal-header">
                            <h5 className="modal-title" id="pageInsightModal">
                                Facebook Page Insights
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="modal-body">

                            {/* Reach Stats */}
                            <div className="row mb-3">

                                <div className="col-sm-6 col-lg-4">
                                    <div className="card card-body pd-15 text-center">
              <span className="tx-20 tx-color-02">
                <i className="fa fa-eye tx-primary"></i>
              </span>
                                        <h3 id="total-likes" className="tx-normal tx-rubik mg-b-0">
                                            0
                                        </h3>
                                        <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">
                                            Daily Reach
                                        </h6>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-lg-4">
                                    <div className="card card-body pd-15 text-center">
              <span className="tx-20 tx-color-02">
                <i className="fa fa-calendar-week tx-warning"></i>
              </span>
                                        <h3 id="total-comments" className="tx-normal tx-rubik mg-b-0">
                                            0
                                        </h3>
                                        <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">
                                            Weekly Reach
                                        </h6>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-lg-4">
                                    <div className="card card-body pd-15 text-center">
              <span className="tx-20 tx-color-02">
                <i className="fa fa-chart-line tx-success"></i>
              </span>
                                        <h3 id="total-shares" className="tx-normal tx-rubik mg-b-0">
                                            0
                                        </h3>
                                        <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold">
                                            28-Day Reach
                                        </h6>
                                    </div>
                                </div>

                            </div>

                            <hr />

                            {/* Engagement Summary */}
                            <div className="text-center">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold">
                                    Total Engagement (Reach Based)
                                </h6>
                                <p
                                    className="tx-20 tx-md-22 tx-normal tx-rubik mg-b-0"
                                    id="total-engagements"
                                >
                                    0
                                </p>
                                <small className="tx-color-03">
                                    Aggregated reach across selected time ranges
                                </small>
                            </div>

                            <hr />

                            {/* Page Info */}
                            <div>
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-10">
                                    Page Information
                                </h6>

                                <a
                                    href="https://www.facebook.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-02"
                                    id="page-link"
                                >
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="media">
                                            <div className="crypto-icon crypto-icon-sm bg-primary">
                                                <img
                                                    id="page-logo"
                                                    src=""
                                                    className="ht-50 rounded-30"
                                                    alt="Page logo"
                                                />
                                            </div>
                                            <div className="media-body mg-l-15">
                                                <p className="tx-medium mg-b-0" id="page-name">
                                                    Page Name
                                                </p>
                                                <p
                                                    className="mg-b-0 tx-12 tx-color-03 tx-medium tx-spacing-1"
                                                    id="page-category"
                                                >
                                                    Category
                                                </p>
                                            </div>
                                        </div>

                                        <div className="text-end">
                                            <p className="tx-normal tx-rubik mg-b-0">
                                                Followers
                                            </p>
                                            <p
                                                className="tx-normal tx-rubik mg-b-0"
                                                id="page-follower"
                                            >
                                                0
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserReport;
